import { Backdrop, CircularProgress } from "@mui/material";
import About from "../components/about/About";
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import ReportForm from "../components/forms/ReportForm";
import Header from "../components/landing/Header";
import QuickLinks from "../components/landing/QuickLinks";
import Reports from "../components/reports/Reports";
import Podcast from "../components/social/Podcast";
import VideoSection from "../components/videos/VideoSection";
import useWebsite from "../services/useWebsite";
import "./styles/Home.css";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import BlogStack from "./BlogStack";

export default function Home() {
	const { website } = useWebsite();
	const location = useLocation();

	useEffect(() => {
		if (location.pathname === "/denuncias") {
			setTimeout(() => {
				document
					.getElementById("denuncias")
					?.scrollIntoView({ behavior: "smooth" });
			}, 1500);
		} else if (location.pathname === "/contacto") {
			setTimeout(() => {
				document
					.getElementById("podcast")
					?.scrollIntoView({ behavior: "smooth" });
			}, 1500);
		} else if (location.pathname === "/about") {
			setTimeout(() => {
				document
					.getElementById("about")
					?.scrollIntoView({ behavior: "smooth" });
			}, 1500);
		} else if (location.pathname.includes("/blogs")) {
			setTimeout(() => {
				document
					.getElementById("blogs")
					?.scrollIntoView({ behavior: "smooth" });
			}, 1500);
		}
	}, [location]);

	return (
		<div className="container-home">
			{website ? (
				<>
					<div>
						<a
							href="https://www.whatsapp.com/channel/0029Vami4f7HwXbCtmcfIP0J"
							target="__blank"
						>
							<img
								className="whatsapp"
								src={require("../assets/social/comunidad.png")}
								alt="comunidad.png"
							/>
						</a>
					</div>
					<Header item={website.banner} />
					<Banner item={website.banner} />
					<QuickLinks />
					<About item={website.about} />
					<BlogStack />
					<VideoSection item={website.testimonials} />
					<Reports item={website.reports} />
					<ReportForm item={website.reportForm} />
					<Podcast item={website.contact} />
					<Footer item={website.footer} />
				</>
			) : (
				<div
					style={{
						width: "100%",
						backgroundImage: `url("https://firebasestorage.googleapis.com/v0/b/danielbricen-cc9d9.appspot.com/o/assets%2Fbanner%2Fbanner.png?alt=media&token=9950b1e7-8a99-4c80-adda-a9de8b825894"), linear-gradient(to bottom, white 50%, white 50%)`,
						backgroundSize: "cover",
						backgroundPosition: "center",
						minHeight: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Backdrop open={!website}>
						<CircularProgress color="primary" />
					</Backdrop>
				</div>
			)}
		</div>
	);
}
